import styled from 'styled-components';

import type { ExtendedTheme } from '@theme/theme';

export const StyledSkeletonContent = styled.div`
  display: grid;
  grid-template-columns: minmax(auto, 860px) 1fr;
  grid-template-rows: 1fr;
  gap: 0 40px;
  padding: 0 60px 60px;

  ${({ theme }: { theme: ExtendedTheme }) => theme.breakpoints.up('xxl')} {
    padding-left: 100px;
  }

  ${({ theme }: { theme: ExtendedTheme }) => theme.breakpoints.down('md')} {
    grid-template-columns: 1fr;
    padding: 0 40px 60px;
  }

  ${({ theme }: { theme: ExtendedTheme }) => theme.breakpoints.down('sm')} {
    padding: 0 0 60px;
  }

  .MuiSkeleton-root {
    background: ${({ theme }: { theme: ExtendedTheme }) => theme.palette.components.cardBgPressed};
    border-radius: 2px;
  }

  .content,
  .toc {
    flex-direction: column;
  }

  .content {
    span {
      margin-bottom: 8px;
    }
  }

  .toc {
    ${({ theme }: { theme: ExtendedTheme }) => theme.breakpoints.down('md')} {
      display: none;
    }

    &__items {
      margin-top: 16px;
      border-left: 1px solid rgba(20, 20, 20, 0.16);
      padding: 14px 0 14px 14px;

      span {
        &:not(:last-child) {
          margin-bottom: 28px;
        }
      }
    }
  }
`;
